import React from 'react'
import PropTypes from 'prop-types'

import { Item } from '@generators/htmlComponents/Item'
import colors from '@settings/styleSettings'
import { getDateFromStringDate } from '@util/timeUtil'
import sexEnum from '@util/sexEnum'

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
}

const BeneficiaryInfo = ({
  name,
  cpf,
  sex,
  birthdate,
  age,
  insuranceNumber,
  collectedAt,
  insurer
}) => {
  return (
    <>
      <Item
        label="Nome"
        text={name}
        textColor={insurer === 1 ? colors.strongGreen : colors.strongRed}
        width={560}
      />
      <div style={styles.section}>
        <Item label="CPF" text={cpf} />
        <Item label="Sexo" text={sexEnum[sex]?.label} />
        <Item label="Carteirinha" text={insuranceNumber || 'Não informado'} />
      </div>
      <div style={styles.section}>
        <Item
          label="Data de nascimento"
          text={getDateFromStringDate(birthdate) || 'Não informado'}
        />
        <Item label="Idade" text={age ? `${age} anos` : 'Não informado'} />
        <Item
          label="Data da coleta"
          text={getDateFromStringDate(collectedAt)}
        />
      </div>
    </>
  )
}

BeneficiaryInfo.propTypes = {
  name: PropTypes.string.isRequired,
  cpf: PropTypes.string.isRequired,
  sex: PropTypes.string.isRequired,
  birthdate: PropTypes.string,
  age: PropTypes.number,
  insuranceNumber: PropTypes.string,
  collectedAt: PropTypes.string.isRequired,
  insurer: PropTypes.number.isRequired,
}

BeneficiaryInfo.defaultProps = {
  insuranceNumber: null,
  birthdate: null,
  age: null,
}

export default BeneficiaryInfo
